import React, { useEffect, useState } from 'react'
import { ServerRequestPublic } from '../../../../../../../../utils/ServerDataRequest';
import { enumUtil } from '../../../../../../../../utils/Enum';


const SignImagePreview = ({ BucketPath, ...props }) => {
    const API_URL_Wasabi = enumUtil.controller.Wasabi;
    const [imgFile, setImgFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (BucketPath) {
            setIsLoading(true);
            ServerRequestPublic(
                API_URL_Wasabi + "/DownloadFile",
                "post",
                { BucketPath },
                "Download"
            )
                .then((response) => {
                    setIsLoading(false);

                    if (["application/png", "application/jpg", "application/jpeg", "application/tiff"].includes(response.type)) {
                        const blob = response;
                        const objectURL = URL.createObjectURL(blob);
                        setImgFile(objectURL);
                    }
                })
                .catch(() => {
                    setImgFile(null);
                    setIsLoading(false)
                });
        }
    }, [BucketPath]);

    //   if (!imgFile) return null;
    return (
        <>
            {isLoading ?
                <div className="ar-small-loader last_loader">
                    <div className="circle circle1"></div>
                    <div className="circle circle2"></div>
                </div>
                :
                <img
                    src={imgFile}
                    // style={{ maxHeight: "40px" }}
                    className='signature-img'
                    alt="Uploaded preview"
                />
            }
        </>
    );
};

export default SignImagePreview